<template>
     <menu-layout :loading="loading || checkingTrustedDevice">
          <v-card style="max-width: 1000px" >
            <div>
              <v-tabs v-model="tab" show-arrows bg-color="white" grow>
                  <v-tab style="align-items: flex-start; margin-left: 11px;" v-for="(i, index) in tabs" :key="index">
                    <div class="d-flex align-center">
                      <v-icon color="rgba(0, 0, 0, 0.6)" size="large" class="mr-2">{{ i.icon }}</v-icon>
                      <div style="color: rgba(0, 0, 0, 0.6)" class="py-1">{{ i.name }}</div>
                    </div>
                  </v-tab>
              </v-tabs>
              <v-tabs-window v-model="tab">
                  <v-tabs-window-item>
                      <v-card class="px-4">
                          <v-card-text>
                              <v-alert
                                v-if="loginBanner"
                                type="error"
                                variant="tonal"
                                class="mb-4"
                                closable
                                @click:close="loginBanner = null"
                              >
                                <div>{{ loginBanner.message }}</div>
                                <div v-if="loginBanner.kind === 'unconfirmed'" class="mt-3">
                                  <v-btn
                                    color="primary"
                                    size="small"
                                    :loading="resendLoading"
                                    @click="resendConfirmationFromLogin"
                                  >
                                    {{ $t('login.resend_email') }}
                                  </v-btn>
                                </div>
                              </v-alert>
                              <v-form ref="loginForm" v-model="valid" lazy-validation>
                                <v-row>
                                  <v-col cols="12">
                                      <v-text-field id="email" v-model="userEmail" :rules="emailValidationMessage" :label="$t('login.email')" required></v-text-field>
                                  </v-col>
                                  <v-col cols="12">
                                      <v-text-field id="password" v-on:keydown.enter="validate('loginForm')" v-model="loginPassword" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[requiredRule, minRule(6)]" :type="show1 ? 'text' : 'password'" name="input-10-1" :label="$t('login.password')" :hint="this.$t('login.min_charact')" counter @click:append="show1 = !show1"></v-text-field>
                                  </v-col>
                                  <v-col cols="12">
                                    <v-text-field v-if="show_otp" id="otp" v-on:keydown.enter="validate('loginForm')" v-model="otp" :label="this.$t('login.generated_otp')" required></v-text-field>
                                  </v-col>
                                  <v-col cols="12">
                                    <v-checkbox
                                      v-model="trustComputer"
                                      :label="$t('login.trust_computer')"
                                      :hint="$t('login.trust_computer_hint')"
                                      persistent-hint
                                    ></v-checkbox>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col class="d-flex" cols="3" sm="3" xsm="3">
                                      <v-btn large block :disabled="!valid" color="primary" @click="validate('loginForm')"> {{$t('login.login')}} </v-btn>
                                  </v-col>
                                  <v-spacer></v-spacer>
                                  <v-col @click="goToResetPassword" cols="12" sm="3" xsm="12" style="text-align: right">
                                      <span style="text-decoration: underline; cursor: pointer; text-align: right">{{$t('login.reset_password')}}</span>
                                  </v-col>
                                  
                                </v-row>
                              </v-form>
                          </v-card-text>
                      </v-card>
                  </v-tabs-window-item>
                  <v-tabs-window-item>
                      <v-card class="px-4">
                          <v-card-text>
                              <v-form ref="registerForm" v-model="valid" lazy-validation>
                                  <v-row v-if="!registerSuccess">
                                      <v-col cols="12" sm="6" md="6">
                                          <v-text-field v-model="firstName" :rules="[requiredRule]" :label="$t('login.first_name')" maxlength="20" required></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="6" md="6">
                                          <v-text-field v-model="lastName" :rules="[requiredRule]" :label="$t('login.last_name')" maxlength="20" required></v-text-field>
                                      </v-col>
                                      <v-col cols="12">
                                          <v-text-field v-model="email" :rules="emailValidationMessage" :label="$t('login.email')" required></v-text-field>
                                      </v-col>
                                      <v-col cols="12">
                                          <v-text-field v-model="password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[requiredRule, minRule(6)]" :type="show1 ? 'text' : 'password'" name="input-10-1" :label="$t('login.password')" :hint="$t('login.hint')" counter @click:append="show1 = !show1"></v-text-field>
                                      </v-col>
                                      <v-col cols="12">
                                          <v-text-field block v-model="verify" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[requiredRule, passwordMatch]" :type="show1 ? 'text' : 'password'" name="input-10-1" :label="$t('login.confirm_password')" counter @click:append="show1 = !show1"></v-text-field>
                                      </v-col>
                                      <v-spacer></v-spacer>
                                      <v-col class="d-flex" cols="12" sm="3" xsm="12" align-end>
                                        <!-- Move the Register button here -->
                                        <v-btn large block :disabled="!valid" color="primary" @click="validate('registerForm')">{{$t('login.register_button')}}</v-btn>
                                      </v-col>
                                  </v-row>
                                  <v-row v-else>
                                    <v-col cols="12">
                                      <p><b>{{$t('login.email_sent')}} <v-icon large class="mr-2">mdi-email</v-icon></b></p>
                                      <p>{{$t('login.confirm_registration')}}</p>
                                      <p>{{$t('login.didnt_get_email')}}</p>
                                      <v-btn color="primary" @click="resendConformationEmail">{{$t('login.resend_email')}}</v-btn>
                                    </v-col>
                                  </v-row>
                              </v-form>
                          </v-card-text>
                      </v-card>
                  </v-tabs-window-item>
              </v-tabs-window>
            </div>
          </v-card>
        <!-- </v-dialog> -->
     </menu-layout>
</template>

<script>
import MenuLayout from "@/components/layout/MenuLayout";
import TrustedDeviceMixin from "@/mixins/TrustedDeviceMixin.vue";

export default {
  name: 'Login',
  components: {
    MenuLayout,
  },
  mixins: [TrustedDeviceMixin],
  mounted() {
    const tab = this.$route.query.tab;
    if (tab === "register") {
      this.tab = 1;
    }
    
    // Check for trusted device and auto-login
    this.checkTrustedDevice();
  },  
  computed: {
    passwordMatch() {
      return () => this.password === this.verify || this.$t('login.password_match');
    },
    tabLogin() {
      return this.$t('login.tab_login');
    },
    tabRegister() {
      return this.$t('login.tab_register');
    },
    tabs() {
      return [
        { name: this.tabLogin, icon: "mdi-account" },
        { name: this.tabRegister, icon: "mdi-account-outline" }
      ];
    },
    emailValidationMessage() {
      return [
        v => !!v || this.$t('login.required'),
        v => /.+@.+\..+/.test(v) || this.$t('login.valid_email')
      ];
    },
    requiredRule() {
      return v => !!v || this.$t('login.required');
    },
    minRule() {
      return min => v => (v && v.length >= min) || this.$t('login.min_charact');
    },
  },
  methods: {
    
    async validate(formType) {
      if (formType === 'loginForm') {
        await this.handleLoginForm();
      } else if (formType === 'registerForm') {
        await this.handleRegisterForm();
      }
    },
    async handleLoginForm() {
      const { valid } = await this.$refs.loginForm.validate();
      if (!valid) {
        return;
      }
      if (!this.userEmail) {
        await this.$store.dispatch('snackbars/add_failed_snack', this.$t('login.missing_email'));
        return;
      }

      this.loginBanner = null;
      this.loading = true;
      try {
        let response = await this.$api.user.check_confirmation_status(this.userEmail);
        if (response && response.error) {
          this.loginBanner = { kind: 'unknown', message: response.error };
          await this.$store.dispatch('snackbars/add_failed_snack', {
            message: response.error,
            timeout: 6000,
          });
          return;
        }
        if (!response || !response.confirmed) {
          const msg = this.$t('login.unconfirmed_login_message');
          this.loginBanner = { kind: 'unconfirmed', message: msg };
          await this.$store.dispatch('snackbars/add_failed_snack', {
            message: msg,
            timeout: 8000,
          });
          return;
        }

        // If the account uses 2FA and we have not asked for the code yet, reveal
        // the OTP field and wait for it. The code itself is verified server-side
        // as part of the login request below, so it cannot be bypassed.
        if (!this.show_otp) {
          let twofa = await this.$api.user.user_2fa_enabled_login(this.userEmail);
          if (twofa && twofa.authentication_enabled) {
            this.show_otp = true;
            return;
          }
        }

        await this.submitLogin();
      } catch (e) {
        console.error(e);
        const msg = this.$t('login.something_went_wrong');
        this.loginBanner = { kind: 'error', message: msg };
        await this.$store.dispatch('snackbars/add_failed_snack', { message: msg, timeout: 6000 });
      } finally {
        this.loading = false;
      }
    },
    async resendConfirmationFromLogin() {
      if (!this.userEmail || !this.userEmail.trim()) {
        await this.$store.dispatch('snackbars/add_failed_snack', this.$t('login.missing_email'));
        return;
      }
      this.resendLoading = true;
      try {
        const response = await this.$api.resend_confirmation_email(this.userEmail.trim());
        if (response && (response.success || response.error === undefined)) {
          await this.$store.dispatch('snackbars/add_success_snack', this.$t('login.email_resend'));
        } else if (response && response.error) {
          await this.$store.dispatch('snackbars/add_failed_snack', response.error);
        } else {
          await this.$store.dispatch('snackbars/add_failed_snack', this.$t('login.something_went_wrong'));
        }
      } finally {
        this.resendLoading = false;
      }
    },
    async submitLogin() {
      if (this.show_otp && !this.otp) {
        await this.$store.dispatch('snackbars/add_failed_snack', this.$t('login.otp_missing'));
        return;
      }

      let result = await this.$api.set_token(this.userEmail, this.loginPassword, this.trustComputer, this.otp);
      if (result && result.success) {
        const redirect = this.$route.query.redirect;
        if (typeof redirect === 'string' && redirect.startsWith('/') && !redirect.startsWith('//')) {
          this.$router.push(redirect);
        } else {
          this.$router.push('/projects');
        }
        return;
      }

      if (result && result.locked) {
        await this.$store.dispatch('snackbars/add_failed_snack', {
          message: this.$t('login.account_locked'),
          timeout: 10000,
        });
        this.loading = false;
        return;
      }

      if (result && result.requires_2fa) {
        // Either the OTP was wrong or one is needed; make sure the field is shown.
        this.show_otp = true;
        await this.$store.dispatch('snackbars/add_failed_snack', this.$t('login.invalid_otp'));
      } else {
        await this.$store.dispatch('snackbars/add_failed_snack', this.$t('login.invalid_creds'));
      }
      this.loading = false;
    },
    async handleRegisterForm() {
        const { valid } = await this.$refs.registerForm.validate();
        if (valid) {
            this.loading = true;
            let register_response = await this.$api.register(this.firstName, this.lastName, this.email, this.password)
                .then(response => {
                    if (response.success) {
                        this.registerSuccess = true;
                        this.$store.dispatch('snackbars/add_success_snack', this.$t('login.check_email'));
                    } else if (response.error) {
                        if (response.error === 'User already exists') {
                            this.$store.dispatch('snackbars/add_failed_snack', this.$t('login.email_already_exists'));
                        } else {
                            this.$store.dispatch('snackbars/add_failed_snack', this.$t('login.something_went_wrong'));
                        }
                    } else {
                        return this.$api.set_token(this.email, this.password)
                            .then(login_success => {
                                if (login_success && login_success.success) {
                                    return this.$api.project.all()
                                        .then(projects => {
                                            if (projects.length > 0) {
                                                let firstProjectId = projects[0].id;
                                                this.$router.push(`/project/${firstProjectId}`);
                                                this.$store.dispatch('snackbars/add_success_snack', {
                                                    'message': 'Registered successfully',
                                                });
                                            }
                                        });
                                }
                            });
                    }
                })
                .finally(() => {
                    this.loading = false;
                });

            await register_response;
        }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    async resendConformationEmail() {
      if (this.email) {
        let response = await this.$api.resend_confirmation_email(this.email);
        if (response && response.success) {
          await this.$store.dispatch('snackbars/add_success_snack', this.$t('login.email_resend'));
        } else {
          await this.$store.dispatch(
            'snackbars/add_failed_snack',
            (response && response.error) || this.$t('login.something_went_wrong'),
          );
        }
      }
    },
    goToResetPassword() {
      this.$router.push('/reset-password')
    },
  },
  data: () => ({
    loading: false,
    checkingTrustedDevice: false,
    dialog: true,
    tab: 0,
    valid: true,
    
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    verify: "",
    loginPassword: "",
    userEmail: "",
    show1: false,
    show_otp: false,
    otp: '',
    registerSuccess: false,
    trustComputer: false,
    loginBanner: null,
    resendLoading: false,
  })
  
};
</script>

<style></style>